export default __webpack_public_path__ + "static/media/Sponsor_intro_1.62621fa2.png";